import { defineMessages } from 'react-intl';

export default defineMessages({
    coveragesHeading: {
        id: "quoteandbind.wizard.commercial.TWIA.Coverages.Coverages",
        defaultMessage: "Coverages"
    },
    editCoverages: {
        id: "quoteandbind.wizard.commercial.TWIA.Coverages.Edit Coverages",
        defaultMessage: "Edit Coverages"
    },
    concatWordforCoverages:{
        id: "quoteandbind.wizard.commercial.TWIA.Coverages.plus",
        defaultMessage: "plus"
    }
})